var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGradientarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.13416 7.25725C0.581871 7.25725 0.134155 7.70496 0.134155 8.25725C0.134155 8.80953 0.58187 9.25725 1.13416 9.25725L1.13416 8.25725L1.13416 7.25725ZM16.7072 8.96436C17.0977 8.57383 17.0977 7.94067 16.7072 7.55014L10.3433 1.18618C9.95274 0.795656 9.31957 0.795656 8.92905 1.18618C8.53852 1.5767 8.53852 2.20987 8.92905 2.60039L14.5859 8.25725L8.92905 13.9141C8.53852 14.3046 8.53852 14.9378 8.92905 15.3283C9.31957 15.7188 9.95274 15.7188 10.3433 15.3283L16.7072 8.96436ZM1.13416 8.25725L1.13416 9.25725L16.0001 9.25725L16.0001 8.25725L16.0001 7.25725L1.13416 7.25725L1.13416 8.25725Z",
    fill: "url(#paint0_linear_3536_20492)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3536_20492",
    x1: 1.13416,
    y1: 8.75725,
    x2: 16.0001,
    y2: 8.75725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3AB1F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#407BFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradientarrow);
export default __webpack_public_path__ + "static/media/gradient arrow.ecdc4c5ae32f08b7c7fe1dc6ad696589.svg";
export { ForwardRef as ReactComponent };